module.exports = __webpack_public_path__ + "img/LAST_ACTIVITIES.4c41e4d9.svg";